import { TextField } from "@mui/material";

const fields = [
  { label: "Control #", key: "control" },
  { label: "Unit #", key: "unit" },
  { label: "Chassis #", key: "chassis" },
  { label: "Reference #", key: "reference" },
  { label: "Booking", key: "booking" },
  { label: "Bill To", key: "billtoNumber" },
  { label: "Order By Code", key: "orderByCode" },
  // { label: "ELEOS Conf #", key: "eleosConf" }
];

export default function FieldSearchForm({ values, onChange,disabled }) {
  return (
    <>
      {fields.map(({ label, key }) => (
        <TextField
          key={key}
          size="small"
          fullWidth
          label={label}
          value={values[key] || ""}
          disabled={disabled}
          onChange={(e) =>
            onChange({
              ...values,
              [key]: e.target.value
            })
          }
          sx={{ mb: 1 }}
        />
      ))}
    </>
  );
}










